"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChaveModeloCentroTrabalho = void 0;
var ChaveModeloCentroTrabalho = /** @class */ (function () {
    function ChaveModeloCentroTrabalho(_a) {
        var _b = _a._id, _id = _b === void 0 ? { CHAVE_MODELO: '', CENTRO_TRAB: '' } : _b, _c = _a.CHAVE_MODELO, CHAVE_MODELO = _c === void 0 ? '' : _c, _d = _a.CENTRO_TRAB, CENTRO_TRAB = _d === void 0 ? '' : _d;
        this._id = _id;
        this.CHAVE_MODELO = CHAVE_MODELO;
        this.CENTRO_TRAB = CENTRO_TRAB;
    }
    return ChaveModeloCentroTrabalho;
}());
exports.ChaveModeloCentroTrabalho = ChaveModeloCentroTrabalho;
//# sourceMappingURL=ChaveModeloCentroTrabalho.js.map